import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { EmailAndDisplayNameForm } from './EmailAndDisplayNameForm';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { IServerUserInfo } from '../../ts/models/IServerUserInfo';
import { buttonCell, userNameThirdCell } from '../styles/EmailAndDisplayNameFormStyles';

export interface GeneralAuthSettingsProps {
  //auth families
  isDomainFamilyLocal: boolean;
  isDomainFamilyExternal: boolean;
  isDomainFamilyAD: boolean;
  //data
  emailFormInitialValues: EmailAndDisplayNameForm.FormFields;
  //meta data realted to business logic
  updateDisplayNameAllowed: boolean;
  siteUser: ISiteUserInfo;
  serverUser: IServerUserInfo;
  isViewerServerAdmin: boolean;
  isViewerSelf: boolean;
}

export function GeneralAuthSettings({emailFormInitialValues, ...passThroughProps}: GeneralAuthSettingsProps) {
  const emailAndDisplayNameFormProps: EmailAndDisplayNameForm.Props = {
    initialValues: emailFormInitialValues,
    ...passThroughProps,
    handleSubmit: EmailAndDisplayNameForm.handleSubmit
  };
  return (
    <table>
      <tbody>
        {/* username section */}
        {(passThroughProps.isDomainFamilyAD || passThroughProps.isViewerServerAdmin || passThroughProps.isViewerSelf) &&
          <tr>
            <td className="tb-nested-table" colSpan={3}>
                <table>
                  <tbody>
                    <tr id="settings-username">
                      <td className="tb-label">{Messages.username()}</td>
                      <td className="tb-details-value" tb-test-id="tb-username-value-id">{passThroughProps.serverUser.username}</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
            </td>
          </tr>
        }
        <tr>
          <td className="tb-nested-table" colSpan={3}>
            <EmailAndDisplayNameForm.Form {...emailAndDisplayNameFormProps}/>
          </td>
        </tr>
        {/* Placeholder for passwordChangeSetting from userSettingsMixin.pug in future */}
      </tbody>
    </table>
  );
}